export function useUrlWithParams(url: string, queryParams?: Record<string, unknown>): string {
  if (!url.startsWith('/')) url = `/${url}`
  if (!queryParams || Object.keys(queryParams).length === 0) return url

  const queryString = Object.entries(queryParams)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join('&')

  return `${url}?${queryString}`
}
